import { fileSerializer } from 'modules/global/serializers/fileSerializer';
import { Curator } from '../types/Curator';

export const curatorSerializer = (curator: Curator): Curator => ({
  ...curator,
  profilePicture: fileSerializer(curator.profilePicture),
  additionalPicture: fileSerializer(curator.additionalPicture),
});
